var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRcDuplicate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-rc-duplicate",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M640 256c38.4 0 64 25.6 64 64v576c0 38.4-25.6 64-64 64H192c-38.4 0-64-25.6-64-64V320c0-38.4 25.6-64 64-64h448z m0 64H192v576h448V320z m192-256c38.4 0 64 25.6 64 64v576c0 38.4-25.6 64-64 64h-64v-64h64V128H384v64H320V128c0-38.4 25.6-64 64-64h448z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcDuplicate);
export default __webpack_public_path__ + "static/media/rc-duplicate.f8825995404b527f760b3d62465b2792.svg";
export { ForwardRef as ReactComponent };